import { render, staticRenderFns } from "./WorkGroup.vue?vue&type=template&id=5cf676cd"
import script from "./WorkGroup.vue?vue&type=script&lang=ts"
export * from "./WorkGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports